<script>
import MessageFormatter from 'shared/helpers/MessageFormatter';
import { escapeHtml } from 'shared/helpers/HTMLSanitizer';
import { SIGNATURE_SOURCES } from 'dashboard/helper/signature';

export default {
  props: {
    // the signature that will be appended to the message, variables already resolved
    signature: {
      type: String,
      default: '',
    },
    source: {
      type: String,
      default: SIGNATURE_SOURCES.AGENT,
    },
    isForcedByInbox: {
      type: Boolean,
      default: false,
    },
    /**
     * Sem moldura: usado no editor de resposta, onde o indicador e uma linha
     * de apoio e nao um chip. As demais telas seguem com o chip.
     */
    plain: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isInboxSignature() {
      return this.source === SIGNATURE_SOURCES.INBOX;
    },
    label() {
      return this.isInboxSignature
        ? this.$t('CONVERSATION.FOOTER.SIGNATURE_INDICATOR.INBOX')
        : this.$t('CONVERSATION.FOOTER.SIGNATURE_INDICATOR.AGENT');
    },
    // the preview is rendered as markdown so the agent sees the signature
    // exactly as it will be sent, formatting included
    signaturePreview() {
      const signature = (this.signature || '').trim();

      if (!signature) return '';

      return new MessageFormatter(signature).formattedMessage;
    },
    tooltip() {
      if (!this.signaturePreview) return '';

      const label = escapeHtml(
        this.isForcedByInbox
          ? this.$t('CONVERSATION.FOOTER.SIGNATURE_INDICATOR.FORCED_TOOLTIP')
          : this.$t('CONVERSATION.FOOTER.SIGNATURE_INDICATOR.TOOLTIP')
      );

      return {
        content: `<span class="signature-tooltip__label">${label}</span>${this.signaturePreview}`,
        html: true,
        classes: 'signature-tooltip',
      };
    },
  },
};
</script>

<template>
  <div
    v-tooltip.top-start="tooltip"
    class="inline-flex items-center gap-1 max-w-full text-xs"
    :class="
      plain
        ? ''
        : 'px-2 py-0.5 rounded-md text-slate-600 dark:text-slate-300 bg-slate-50 dark:bg-slate-800 border border-solid border-slate-75 dark:border-slate-700'
    "
  >
    <fluent-icon icon="signature" size="14" class="flex-shrink-0" />
    <span class="truncate">{{ label }}</span>
  </div>
</template>
